import type { ApiResponse, ApiPagination } from '@shared/http/types';

import type { ApiRawEnvelope } from './api-raw-envelope';
import type { ApiRawPagination } from './api-raw-pagination';

function normalizeRawPagination(pagination?: ApiRawPagination): ApiPagination | undefined {
  if (!pagination || typeof pagination !== 'object') {
    return undefined;
  }

  return {
    elements: pagination.elements,
    page: pagination.page,
    perPage: pagination.size,
    totalPages: pagination.total_pages,
    totalElements: pagination.total_elements,
    isFirst: pagination.first,
    isLast: pagination.last,
  };
}

export function unwrapApiEnvelope<T>(envelope: ApiRawEnvelope<T>): ApiResponse<T | null> {
  const payload = envelope?.payload ?? null;

  const pagination = normalizeRawPagination(payload?.pagination);

  return {
    data: payload ? payload.content : null,
    pagination,
  };
}
